export enum LogonResult {
	// not a result
	Failure = 0,
	// authentication succeeded
	Success = 1,
	// a protocol error occurred
	ProtocolError = 2,
	// a network error occurred
	NetworkError = 3,
	// there was a problem with the server's certificate
	CertificateError = 4,
	// an unexpected error occurred
	SystemError = 5,
	// interaction was needed for logon to succeed but was disallowed
	InteractionNotAllowed = 6,
	// the user pressed the cancel button in a logon dialog
	CancelledByUser = 7,
	// logon could not complete due to a security policy
	DisallowedBySecurityPolicy = 8,
	// the authentication server reported an internal problem
	AuthenticationServerError = 9,
	// the gateway session was not valid
	InvalidGatewaySession = 10,
	// the protocol could not be used (e.g. IWA fails due to being disabled in IE)
	UnsuitableProtocol = 11,
	// the gateway type or logon method is not supported
	GatewayNotSupported = 12,
	// the credentials in the gateway session were found to be invalid
	BadGatewaySessionCredentials = 13,
	// access denied
	AccessDenied = 14,
	// the logon was programmatically cancelled by the client application
	Aborted = 15,
	// the server has run out of licenses
	OutOfLicenses = 16,
	// the logon failed because AG client software was upgraded or downgraded
	GatewayClientSoftwareUpdated = 17,
	// the user opted to try another logon method
	UserSwitchedProtocol = 18,
	// server response was not one of authenticateresponse, gatewaysessionresponse
	FormsMimeTypeNotReceived = 19,
	// gateway session has expired trying to make a request with allowcredui false
	GatewaySessionExpired = 20,
}

export interface AuthenticationData {
	result: LogonResult;
	authdata: Map<string, string>;
}

export enum GatewaySessionStatus {
	LOGGED_ON = 'Logged On',
	LOGGED_OFF = 'Logged Off',
	NOT_INITIALIZED = 'Not Initialized',
}

export const GatewayConstants = {
	NSC_AAAC: 'NSC_AAAC',
	NSC_VPNERR: 'NSC_VPNERR',
	RewriteRule: 'UrlRewriteRule',
	StorefrontURL: 'StoreFrontURL',
	FormsStartHeader: 'X-Citrix-Forms-Start',
	StateContext: 'StateContext',
	FormsURLEncoded: 'application/x-www-form-urlencoded',
	ProxyModeKey: 'setclient?',
	RequireTranslate: 'Require-Translate',
};

export const GatewayErrorCodes = {
	InvalidCredentials: '4001',
	BadPassword: '4007',
	NoUser: '4009',
};

export type CredentialType = 'webview' | 'none';

export enum LabelTypeEnumeration {
	Confirmation = 'confirmation',
	Warning = 'warning',
	Error = 'error',
	Plain = 'plain',
	Heading = 'heading',
	Heading2 = 'heading2',
	Information = 'information',
	None = 'none',
	Image = 'image',
	Inprogress = 'inprogress',
	Hint = 'hint',
	Unknown = 'null',
}

export enum CredentialTypeEnumeration {
	None = 'none',
	Username = 'username',
	Domain = 'domain',
	Password = 'password',
	NewPassword = 'newpassword',
	Passcode = 'passcode',
	Pin = 'pin',
	TextCredential = 'textcredential',
	SaveCredentials = 'savecredentials',
	Realm = 'realm',
	RSAPasscode = 'rsa-passcode',
	RSANextPasscode = 'rsa-next-passcode',
	RSANextTokenCode = 'rsa-next-tokencode',
	RSAPin = 'rsa-pin',
	Webview = 'webview',
	Unknown = 'null',
}

export enum InputTypeEnumerationData {
	None = 'none',
	Text = 'text',
	RadioButton = 'RadioButton',
	ComboBox = 'ComboBox',
	MultiComboBox = 'MultiComboBox',
	Button = 'Button',
	CheckBox = 'CheckBox',
	Other = 'Other',
	Unknown = 'null',
}

export enum ResultEnumerationData {
	MoreInfo = 'more-info',
	Cancelled = 'cancelled',
	Fail = 'fail',
	UpdateCredentials = 'update-credentials',
	Success = 'success',
	Unknown = 'null',
}

export const GatewayLocalisedResources = {
	INSECURE_CONNECTION_WARNING_TEXT: 'Connection is not secure',
	SECURE_CONNECTION_CONFIRMATION_TEXT: 'Secure connection',
	CHALLENGE_HEADING: 'Provide more information',
	USERNAME_LABEL: 'User name:',
	PASSWORD_LABEL: 'Password:',
	PASSCODE_LABEL: 'Passcode:',
	PASSWORD2_LABEL: 'Password 2:',
	PASSWORD1_LABEL: 'Password 1:',
	INVALID_USERNAME_OR_PASSWORD_WARNING: 'Incorrect user name or password',
	INVALID_USERNAME_OR_PASSWORD_OR_PASSCODE_WARNING:
		'Incorrect user name, password, or passcode',
	INVALID_USERNAME_OR_PASSCODE_WARNING: 'Incorrect user name or passcode',
	OK_BUTTON_LABEL: 'OK',
	LOGON_BUTTON_LABEL: 'Sign In',
	CANCEL_BUTTON_LABEL: 'Cancel',
};
